// Copyright (c) 2021 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import isDealershipModalOpen from './is-dealership-modal-open';
import massLaborRate from './mass-labor-rate';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    isDealershipModalOpen,
    massLaborRate
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/reducers/index.js